<template>
    <a v-if="url.length > 0" class="o-button" :class='classes' v-bind="data" :href="url" :target="target">
        <div class="-button-main">
            <span v-if="text.length > 0" class="o-button__text">{{ text }}</span>
            <span v-if="accessibilityText.length > 0" class="sr-only">{{ accessibilityText }}</span>

            <Svg v-if="icon.length > 0" :id="icon" :classes="iconClasses" />
        </div>
        <div class="-button-hover" aria-hidden="true">
            <span v-if="text.length > 0" class="o-button__text">{{ text }}</span>
            <span v-if="accessibilityText.length > 0" class="sr-only">{{ accessibilityText }}</span>

            <Svg v-if="icon.length > 0" :id="icon" :classes="iconClasses" />
        </div>
    </a>
    <button v-else-if="tag === 'button'" class="o-button" :class='classes' v-bind="data" :type="type">
        <div class="-button-main">
            <span v-if="text.length > 0" class="o-button__text">{{ text }}</span>
            <span v-if="accessibilityText.length > 0" class="sr-only">{{ accessibilityText }}</span>

            <Svg v-if="icon.length > 0" :id="icon" :classes="iconClasses" />
        </div>
        <div class="-button-hover" aria-hidden="true">
            <span v-if="text.length > 0" class="o-button__text">{{ text }}</span>
            <span v-if="accessibilityText.length > 0" class="sr-only">{{ accessibilityText }}</span>

            <Svg v-if="icon.length > 0" :id="icon" :classes="iconClasses" />
        </div>
    </button>
</template>

<script setup>
import Svg from '@/js/components/Svg.vue';

const props = defineProps({
    url: {
        type: String,
        default: 'https://www.stereo.ca'
    },
    text: {
        type: String,
        default: 'Stereo'
    },
    classes: {
        type: String,
        default: '-stereo'
    },
    icon: {
        type: String,
        default: 'arrow-full-right'
    },
    iconClasses: {
        type: String,
        default: '-icon-arrow-full-right'
    },
    target: {
        type: String,
        default: '_blank'
    },
    accessibilityText: {
        type: String,
        default: 'Redirection vers le site de Stereo'
    },
    data: {
        type: Object,
        default: {
            'data-scroll-to': true,
            'data-scroll-to-offset': "-118"
        },
    },
    type: {
        type: String,
        default: 'submit'
    }
});

const tag = props.url && props.url.length > 0 ? 'a' : (props.data && props.data.length > 0) || (props.type && props.type.length > 0) ? 'button' : 'span';
</script>
